import React, { Component } from 'react';
import axios from 'axios'
import { BrowserRouter, Route,  Navigate } from 'react-router-dom'

import { Panel } from 'primereact/panel';

import Server from './../Server.js'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import { Checkbox } from 'primereact/checkbox';
import { confirmAlert } from 'react-confirm-alert';
import { AutoComplete } from 'primereact/autocomplete';
import { Chip } from 'primereact/chip';
import { connect } from 'react-redux';
import { Loader } from 'rsuite';
import { Toast } from "primereact/toast";

class TravelRobot_UserList extends React.Component {
    constructor(props) {
        super(props);
        this.Server = new Server();

        this.toast = React.createRef();

        this.CreateForm = this.CreateForm.bind(this);
        this.onHideFormsDialog = this.onHideFormsDialog.bind(this);
        this.SetEvent = this.SetEvent.bind(this);

        this.state = {
            layout: 'list',
            name: "",
            ShopsList: [],
            type: "1",
            FId: "",
            DbTableName: "",
            usersList: [],
            DBTableField: "",
            latinName: ""

        }


    }
    componentDidMount() {
        let param = {
            token: localStorage.getItem("api_token"),
        };
        this.setState({
            loading: 1
        })
        let that = this;
        let SCallBack = function (response) {
            that.setState({
                user_Id: response.data.authData.userId,
                loading: 0
            })
            that.getEvents();

        };
        let ECallBack = function (error) {
            that.setState({
                loading: 0
            })
            console.log(error)
        }
        this.Server.send("MainApi/checktoken", param, SCallBack, ECallBack)
    }
    SetEvent() {
        let that = this;
        let param = {
            fTitle: this.state.fTitle,
            lTitle: this.state.lTitle,
            mobile: this.state.mobile,
            type: this.state.type,
            fromCity: this.state.fromCity,
            toCity: this.state.toCity,
            airLine: this.state.airLine,
            supplier: this.state.supplier,
            date: this.state.date,
            sendSms: this.state.sendSms,
            status: this.state.status,
        };
        this.setState({
            HasErrorForMaps: null,
            loading: 1
        })
        let SCallBack = function (response) {
            that.onHideFormsDialog();
            that.getEvents();
            that.setState({
                loading: 0
            })
           that.toast.current.show({severity:'success', summary: '', detail:'عملیات با موفقیت انجام شد', life: 3000});
        };
        let ECallBack = function (error) {
            console.log(error)
            that.setState({
                loading: 0
            })
            that.toast.current.show({severity:'error', summary: 'خطای سرور', detail:'عملیات انجام نشد', life: 3000});
        }
        this.Server.send("AdminApi/setRobotEvent", param, SCallBack, ECallBack)
    }
    CreateForm() {
        this.setState({
            visibleManageField: true,
            fTitle: "",
            lTitle: "",
            mobile: "",
            type: "",
            fromCity: "",
            toCity: "",
            airLine: "",
            supplier: "",
            date: "",
            sendSms: "",
            status: "",
        })

    }
    onHideFormsDialog(event) {
        this.setState({
            visibleManageField: false,
            selectedId: null
        });

    }
    selectedComponentChange(value) {
        let that = this;
        var p = [];
        this.setState({
            fTitle: value.fTitle,
            lTitle: value.lTitle,
            mobile: value.mobile,
            type: value.type,
            fromCity: value.fromCity,
            toCity: value.toCity,
            airLine: value.airLine,
            supplier: value.supplier,
            date: value.date,
            sendSms: value.sendSms,
            status: value.status,
            mobile: value.mobile,
            visibleManageField: true



        })

    }
    getEvents() {
        let that = this;
        let param = {
            token: localStorage.getItem("api_token"),
            GetAll: 1
        };
        this.setState({
            loading: 1
        })
        let SCallBack = function (response) {

            that.setState({
                GridDataFields: response.data.result
            })
            that.setState({
                loading: 0
            })
        };
        let ECallBack = function (error) {
            console.log(error)
            that.setState({
                loading: 0
            })
        }
        this.Server.send("AdminApi/getRobotEvent", param, SCallBack, ECallBack)
    }
    itemTemplate(brand) {
        return (
            <div className="p-clearfix" style={{ direction: 'rtl', maxWidth: '100%' }} >
                <div style={{ margin: '10px 10px 0 0' }} className="row" username={brand.username} >
                    <div className="col-8" username={brand.username} style={{ textAlign: 'right' }}>
                        <span className="iranyekanwebregular" style={{ textAlign: 'right', overflow: 'hidden' }} username={brand.username} >
                            <span style={{ whiteSpace: 'pre-wrap' }} username={brand.username}>{brand.name}</span><br />
                        </span>
                    </div>

                </div>
            </div>
        );
    }
    render() {
        const footer = (
            <div>
                <button className="btn btn-primary irsans" onClick={this.SetEvent} style={{ width: "200px", marginTop: "20px", marginBottom: "20px" }}> اعمال </button>

            </div>
        );
        return (

            <div style={{ direction: 'rtl' }}>
                <Toast
                    ref={this.toast}
                    position="top-left"
                    style={{ fontFamily: "YekanBakhFaBold", textAlign: "right" }}
                />
                {this.state.loading == 1 &&
                    <div style={{ position: 'fixed', zIndex: 2000, top: 10, left: 15, backgroundColor: '#e89f31', padding: '2px 20px' }}>
                        <Loader content="لطفا صبر کنید ..." className="yekan" />
                    </div>
                }
                <div className="row justify-content-center mt-2">

                    <div className="col-12" style={{ background: '#fff' }}>
                        <Panel header="ربات رزرو سفر - لیست مسافران" style={{ textAlign: 'right', fontFamily: 'yekan' }}>
                            <div className="row" >
                                <div className="col-6" style={{ textAlign: 'right' }}>
                                    <button className="btn btn-primary irsans" onClick={this.CreateForm} style={{ width: "200px", marginTop: "20px", marginBottom: "20px" }}>ایجاد رویداد جدید</button>
                                </div>

                            </div>

                            <DataTable responsive value={this.state.GridDataFields} selectionMode="single" selection={this.state.selectedComponent} onSelectionChange={e => this.selectedComponentChange(e.value)}>
                                <Column field="fTitle" header="عنوان فارسی" className="irsans" style={{ textAlign: "right" }} />
                                <Column field="lTitle" header="عنوان لاتین" className="irsans" style={{ textAlign: "right" }} />
                                <Column field="type" header="نوع" className="irsans" style={{ textAlign: "right" }} />
                                <Column field="status" header="وضعیت" className="irsans" style={{ textAlign: "right" }} />

                            </DataTable>
                        </Panel>
                    </div>

                </div>


                <Dialog header={this.state.selectedId ? "مشاهده" : "ساخت مسافر جدید"} visible={this.state.visibleManageField} footer={footer} minY={70}   
                   style={{ width: this.state.isMobile ? "auto" : "60vw" }}
                    onHide={this.onHideFormsDialog} maximizable={false} >
                    <form>

                        <div className="row" style={{ alignItems: 'baseline' }}>
                            <div className="col-lg-6 col-12">
                                <div className="group">
                                    <input className="form-control irsans" autoComplete="off" type="text" value={this.state.fTitle} name="title" onChange={(event) => this.setState({ fTitle: event.target.value })} required="true" />
                                    <label>عنوان فارسی</label>
                                </div>
                            </div>
                            <div className="col-lg-6 col-12">

                                <div className="group">
                                    <input className="form-control irsans" autoComplete="off" type="text" value={this.state.lTitle} name="body" onChange={(event) => this.setState({ lTitle: event.target.value })} required="true" />
                                    <label >عنوان لاتین</label>

                                </div>
                            </div>
                            <div className="col-lg-12 col-12 mt-2 mb-2">
                                <div
                                    style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    }}
                                >
                                    <label className="labelNoGroup irsans">نوع</label>
                                    <select
                                    className="form-control irsans"
                                    style={{ width: 300 }}
                                    value={this.state.type}
                                    onChange={(event) => {
                                        this.setState({
                                            type: event.target.value,
                                        });
                                    }}
                                    >
                                    <option value=""></option>

                                    <option value="getCapacity">ظرفیت پرواز</option>
                                    <option value="setReserve">رزرو پرواز</option>

                                    </select>
                                </div>
                            </div>
                            {(this.state.type == "getCapacity" || this.state.type == "setReserve") &&
                                <div className="row mt-3 mb-3"   >
                                    <div className="col-lg-6 col-12">
                                        <div
                                            style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            }}
                                        >
                                            <label className="labelNoGroup irsans">شهر مبدا</label>
                                            <select
                                            className="form-control irsans"
                                            value={this.state.fromCity}
                                            onChange={(event) => {
                                                this.setState({
                                                    fromCity: event.target.value,
                                                });
                                            }}
                                            >
                                            <option value=""></option>

                                            <option value="ifn">اصفهان</option>
                                            <option value="njf">نجف</option>
                                            <option value="mhd">مشهد</option>
                                            <option value="kih">کیش</option>
                                            <option value="gsm">قشم</option>
                                            <option value="thr">تهران</option>


                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-12">
                                        <div
                                            style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            }}
                                        >
                                            <label className="labelNoGroup irsans">شهر مقصد</label>
                                            <select
                                            className="form-control irsans"
                                            value={this.state.toCity}
                                            onChange={(event) => {
                                                this.setState({
                                                    toCity: event.target.value,
                                                });
                                            }}
                                            >
                                            <option value=""></option>

                                            <option value="ifn">اصفهان</option>
                                            <option value="njf">نجف</option>
                                            <option value="mhd">مشهد</option>
                                            <option value="kih">کیش</option>
                                            <option value="gsm">قشم</option>
                                            <option value="thr">تهران</option>

                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-12 mt-2">
                                        <div
                                            style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            }}
                                        >
                                            <label className="labelNoGroup irsans">خط پروازی</label>
                                            <select
                                            className="form-control irsans"
                                            value={this.state.airLine}
                                            onChange={(event) => {
                                                this.setState({
                                                    airLine: event.target.value,
                                                });
                                            }}
                                            >
                                            <option value=""></option>
                                            <option value="29">ایران آسمان</option>
                                            <option value="32">معراج</option>
                                            <option value="863">وارش</option>
                                            <option value="863">وارش</option>
                                            <option value="9">زاگرس ایر</option>
                                            <option value="1">تابان ایر</option>
                                            <option value="5">کاسپین ایر</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-12 mt-2">
                                        <div
                                            style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            }}
                                        >
                                            <label className="labelNoGroup irsans">تامین کننده</label>
                                            <select
                                            className="form-control irsans"
                                            value={this.state.supplier}
                                            onChange={(event) => {
                                                this.setState({
                                                    supplier: event.target.value,
                                                });
                                            }}
                                            >
                                            <option value=""></option>
                                            <option value="4020">شنتیا</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-12 mt-2">
                                        <div
                                            style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            }}
                                        >
                                            <label className="labelNoGroup irsans">تاریخ</label>
                                            <input className="form-control irsans" autoComplete="off" style={{direction:'ltr'}} type="text" value={this.state.date} name="date" onChange={(event) => this.setState({ date: event.target.value })} placeholder="1401-01-01" required="true" />

                                        </div>
                                    </div>
                                </div>
                            }
                            <div className="col-lg-6 col-12">
                            <div
                              style={{
                                textAlign: "right",
                                display: "flex",
                                alignItems: "flex-start",
                                padding:10
                              }}
                            >
                              <Checkbox
                                inputId="sendSms"
                                value={this.state.sendSms}
                                checked={this.state.sendSms}
                                onChange={(e) =>
                                  this.setState({ sendSms: e.checked })
                                }
                              ></Checkbox>
                              <label
                                htmlFor="sendSms"
                                className="p-checkbox-label yekan"
                                style={{ paddingRight: 5 }}
                              >
                               ارسال پیامک
                              </label>
                            </div>
                               
                            </div>
                            {this.state.sendSms &&
                                <div className="col-lg-12 col-12">
                                    <div className="group">
                                        <input className="form-control irsans" autoComplete="off" style={{direction:'ltr'}} type="text" value={this.state.mobile} name="mobile" onChange={(event) => this.setState({ mobile: event.target.value })} required="true" />
                                        <label> تلفن همراه - با کاما جدا کنید</label>

                                    </div>
                                </div>
                            }
                            <div className="col-lg-12 col-12">
                            <div
                              style={{
                                textAlign: "right",
                                display: "flex",
                                alignItems: "flex-start",
                                padding:10
                              }}
                            >
                              <Checkbox
                                inputId="status"
                                value={this.state.status}
                                checked={this.state.status}
                                onChange={(e) =>
                                  this.setState({ status: e.checked })
                                }
                              ></Checkbox>
                              <label
                                htmlFor="status"
                                className="p-checkbox-label yekan"
                                style={{ paddingRight: 5 }}
                              >
                               فعال
                              </label>
                            </div>
                               
                            </div>




                        </div>
                    </form>
                </Dialog>

            </div>





        )
    }
}
const mapStateToProps = (state) => {
    return {
        systemId: state.systemId,
    }
}
export default connect(mapStateToProps)(TravelRobot_UserList)
